<template>
    <v-card outlined hover class="job-request-card" @click="$emit('click')" style="cursor: pointer; transition: all 0.2s;">
        <v-card-text class="pb-2">
            <div class="d-flex align-center justify-space-between mb-1">
                <span class="text-subtitle-1 font-weight-bold text-truncate" style="max-width: 45%;">{{ request.job_title }}</span>
                <div class="d-flex align-center" style="gap: 4px;">
                    <v-chip x-small :color="getStatusColor(request.status)" dark>{{ request.status }}</v-chip>
                    <v-chip v-if="request.priority" x-small :color="getPriorityColor(request.priority)" dark>{{ request.priority }}</v-chip>
                    <v-btn
                        icon
                        x-small
                        color="error"
                        class="ml-1"
                        title="Delete request"
                        @click.stop="$emit('delete')"
                    >
                        <v-icon x-small>mdi-delete-outline</v-icon>
                    </v-btn>
                </div>
            </div>
            <div class="d-flex align-center flex-wrap text-caption grey--text" style="gap: 12px;">
                <span v-if="request.department">
                    <v-icon x-small class="mr-1">mdi-office-building</v-icon>{{ request.department }}
                </span>
                <span v-if="request.created_at">
                    <v-icon x-small class="mr-1">mdi-calendar</v-icon>{{ formatDate(request.created_at) }}
                </span>
                <span v-if="request.candidates_count !== undefined || (request.candidates && request.candidates.length)">
                    <v-icon x-small class="mr-1">mdi-account-group</v-icon>
                    {{ request.candidates_count || (request.candidates ? request.candidates.length : 0) }} candidates
                </span>
            </div>
            <div v-if="request.hiring_manager_name" class="text-caption grey--text mt-1">
                Manager: {{ request.hiring_manager_name }}
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'JobRequestCard',
    props: {
        request: { type: Object, required: true },
    },
    methods: {
        formatDate(date) {
            if (!date) return '';
            return this.$date(date).format('MMM D, YYYY');
        },
        getStatusColor(status) {
            const map = {
                'Draft': 'grey',
                'Submitted': 'blue-grey',
                'Job Posted': 'blue',
                'Applicants Under Review': 'indigo',
                'Shortlist Created': 'deep-purple',
                'Interviews In Progress': 'orange',
                'Final Decision Pending': 'amber darken-2',
                'Approved': 'green',
                'Offer Accepted': 'teal',
                'Onboarding In Progress': 'cyan',
                'Closed': 'grey darken-2',
            };
            return map[status] || 'grey';
        },
        getPriorityColor(priority) {
            const map = {
                'Urgent': 'red',
                'High': 'orange',
                'Medium': 'blue',
                'Low': 'green',
            };
            return map[priority] || 'grey';
        },
    },
};
</script>
